export function getFilteredList(list, itemKeys) {
  var excludedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return list.filter(function (obj) {
    return Object.keys(obj).some(function (key) {
      return !excludedItems ? itemKeys.includes(key) : !itemKeys.includes(key);
    });
  });
}